import axios from "axios";
import {Base_URL} from "../url"

export const fetchGLMasters = async () => {
  try {
    const response = await axios.get(`${Base_URL}/GeneralLedger/GetAllGeneralLedgers`);
    console.log(response)
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching GL Master data!";
  }
};